var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// React
import React from 'react';
// Material ui
import Grid from '@material-ui/core/Grid/Grid';
import Modal from '@material-ui/core/Modal/Modal';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography/Typography';
import { Button } from "@material-ui/core";
import { deleteAccountStyle } from './deleteAccount.style';
import ModalTemplateDeleteTextEntry from './ModalTemplateDeleteTextEntry';
import { getSvg } from './suppr-compte';
var getDeleteInitRequest = function (InitString) {
    if (!InitString) {
        return;
    }
    return InitString.split(';').reduce(function (headers, name) {
        var _a;
        var _b = name.split(':'), key = _b[0], value = _b[1];
        return __assign(__assign({}, headers), (_a = {}, _a[key] = value, _a));
    }, {});
};
var DeleteAccount = /** @class */ (function (_super) {
    __extends(DeleteAccount, _super);
    function DeleteAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { open: false, success: false };
        _this.handleClick = function (evt) {
            evt.preventDefault();
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            _this.setState({ open: false });
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var init, response, _a, defaultErrorMessage, result, services, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        init = getDeleteInitRequest(this.props.deleteRequestInit);
                        if (!this.props.onDelete) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.onDelete()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, fetch(this.props.deleteAccountUrl, __assign({ method: 'DELETE' }, init))];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        response = _a;
                        if (!response.ok) return [3 /*break*/, 5];
                        this.setState({ success: true, redirectionCountDown: 10 }, function () {
                            return _this.props.deleteAccountRedirectUrl
                                ? _this.launchCountdown(_this.props.deleteAccountRedirectUrl)
                                : undefined;
                        });
                        return [3 /*break*/, 9];
                    case 5:
                        defaultErrorMessage = 'Une erreur est survenue lors de la suppression de vos données.';
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, response.json()];
                    case 7:
                        result = _b.sent();
                        if (result && result.subscribedClients && result.subscribedClients.length) {
                            services = result.subscribedClients.join(' et ');
                            this.setState({
                                error: "Vous \u00EAtes abonn\u00E9 sur notre service " + services + ",\n          pour supprimer votre compte et vos donn\u00E9es, vous devez vous d\u00E9sabonner.",
                                success: false,
                            });
                        }
                        else {
                            this.setState({ success: false, error: defaultErrorMessage });
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _b.sent();
                        this.setState({ success: false, error: defaultErrorMessage });
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        _this.launchCountdown = function (deleteAccountRedirectUrl) {
            var interval = setInterval(function () {
                var redirectionCountDown = _this.state.redirectionCountDown;
                if (redirectionCountDown) {
                    var value = redirectionCountDown - 1;
                    if (!value) {
                        clearInterval(interval);
                        window.location.href = deleteAccountRedirectUrl;
                    }
                    else {
                        _this.setState({ redirectionCountDown: value });
                    }
                }
            }, 1000);
        };
        return _this;
    }
    DeleteAccount.prototype.render = function () {
        var classes = this.props.classes || {};
        var _a = this.props, theme = _a.theme, deleteAccountRedirectUrl = _a.deleteAccountRedirectUrl;
        var _b = this.state, success = _b.success, error = _b.error, redirectionCountDown = _b.redirectionCountDown;
        var ModalTemplateDeleteTextEntryStyled = withStyles(deleteAccountStyle)(ModalTemplateDeleteTextEntry);
        return (React.createElement("div", null,
            React.createElement(Typography, { className: classes.root },
                React.createElement(Button, { variant: 'text', className: classes.link, onClick: this.handleClick }, "Supprimer mon compte et mes donn\u00E9es")),
            React.createElement(Modal, { "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description", open: this.state.open, onClose: this.handleClose },
                React.createElement("div", { className: classes.paper },
                    !success
                        ? React.createElement(ModalTemplateDeleteTextEntryStyled, { handleClose: this.handleClose, handleSubmit: this.handleSubmit })
                        : (React.createElement(Grid, { container: true, justify: "center", spacing: 4 },
                            React.createElement(Grid, { item: true }, getSvg(theme ? theme.palette.primary.main : undefined)),
                            React.createElement(Grid, { item: true },
                                React.createElement(Typography, { className: classes.successDescription, align: "center" }, "Votre compte et vos donn\u00E9es ont bien \u00E9t\u00E9 supprim\u00E9s"),
                                deleteAccountRedirectUrl
                                    ? React.createElement(Typography, { className: classes.successRedirect, align: "center" },
                                        "Vous allez \u00EAtre redirig\u00E9 dans ",
                                        redirectionCountDown,
                                        " seconde",
                                        redirectionCountDown && redirectionCountDown > 1
                                            ? 's'
                                            : undefined)
                                    : undefined))),
                    error
                        ? React.createElement(Typography, { className: classes.error, color: "error" }, error)
                        : undefined))));
    };
    return DeleteAccount;
}(React.Component));
export default DeleteAccount;
//# sourceMappingURL=DeleteAccount.js.map